import { Grid, TextField } from '@mui/material'
import { CompanyType } from '@planning/app/api'
import { usePlanningStore } from '@planning/AppProvider'
import { CompanyAutocomplete } from '@planning/components/autocompletes/company-autocomplete/CompanyAutocomplete'
import { validateContainerNumber } from '@planning/rt-stores/helpers'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { Controller, FieldErrors, useFormContext } from 'react-hook-form'

export const ContainerInfoForm: FC = observer(() => {
  const { t } = useTranslate()
  const { isoCodeMappingInputStore } = usePlanningStore()

  const { register, watch, control, formState } = useFormContext()

  const { errors } = formState

  const containerNumberErrorText = (errors: FieldErrors) => {
    const containerNumberError = errors.number
    if (containerNumberError) {
      const errorType = containerNumberError.type
      if (errorType === 'required') return t('fieldIsRequired', 'Field is required.')
      if (errorType === 'validate')
        return `${t('mustMatchPattern', 'Must match pattern')}: ABCU1234567`

      return containerNumberError.message?.toString()
    }
  }

  return (
    <>
      <Grid
        size={{
          sm: 6,
          xs: 12,
        }}
      >
        <TextField
          data-cy='container-number-field'
          fullWidth
          label={`${t('containerNumber', 'Container Number')}`}
          variant='outlined'
          required
          type='text'
          {...register('number', {
            required: true,
            validate: v => !!v && validateContainerNumber(v),
          })}
          onChange={event => (event.target.value = event.target.value.toUpperCase())}
          name='number'
          error={!!errors.number}
          helperText={containerNumberErrorText(errors)}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <Controller
          control={control}
          name='operator'
          rules={{ required: true }}
          render={({ field }) => (
            <CompanyAutocomplete
              label={t('operator', 'Operator')}
              required
              dataCy='operator-autocomplete'
              selectedCompanyShortName={field.value}
              handleOnChange={operator => {
                field.onChange(operator?.shortName)
              }}
              filterByTypes={[CompanyType.ShippingLine]}
              data-cy='container-operator-field'
            />
          )}
        />
      </Grid>
      <Grid size={12}>
        {isoCodeMappingInputStore.renderIsoCodeMappingInput?.({
          label: `${t('isoCode', 'ISO Code')}`,
          fullWidth: true,
          variant: 'outlined',
          type: 'text',
          uppercase: true,
          formState: formState,
          name: 'isoCode',
          required: true,
          control: control,
          watch: watch,
        })}
      </Grid>
    </>
  )
})
